import { render, staticRenderFns } from "./EditorialSmartLinkItem.vue?vue&type=template&id=694c38c3&scoped=true&"
import script from "./EditorialSmartLinkItem.vue?vue&type=script&lang=js&"
export * from "./EditorialSmartLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./EditorialSmartLinkItem.vue?vue&type=style&index=0&id=694c38c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694c38c3",
  null
  
)

export default component.exports